import tripVars from 'trip-vars'

let varsWithHex = tripVars.getAll(x => x.hexCode != null)
export const screenVarOpts = varsWithHex.map(v => {
  return { value: v.hexCode, text: v.hexCode + ' - ' + v.code }
})

export const backlightOpts = [
  { value: '0x00', text: '00 - Backlight Off' },
  { value: '0x01', text: '01 - Backlight On se veículo ligado' },
  { value: '0x02', text: '10 - Backlight On por certo tempo' },
  { value: '0x03', text: '11 - Backlight On' }
]

export const funcOpts = [
  { value: '0x00', text: '00 - Padrão' },
  { value: '0x01', text: '01 - Digitação Numérica' },
  { value: '0x02', text: '02 - Endereço de Label Dinâmico' }
]

export const buttonOpts = [
  {
    value: '0x00',
    text: '00 - Vai para a tela 0'
  },
  {
    value: '0x01',
    text: '01 - Vai para a tela X',
    paramTypes: ['screenIndex']
  },
  {
    value: '0x02',
    text: '02 - Grava Evento X',
    paramTypes: ['integer']
  },
  {
    value: '0x03',
    text: '03 - Atualiza Checklist: item X com valor Y',
    paramTypes: ['integer', 'integer']
  },
  {
    value: '0x04',
    text: '04 - Invalida Checklist'
  },
  {
    value: '0x05',
    text: '05 - Envia Checklist se OK'
  },
  {
    value: '0x06',
    text: '06 - Set-save variável X com valor Y',
    paramTypes: ['variableName', 'integer']
  },
  {
    value: '0x07',
    text: '07 - Set variável X com valor Y',
    paramTypes: ['variableName', 'integer']
  },
  {
    value: '0x08',
    text: '08 - Vai para a tela indicada pela variável X',
    paramTypes: ['variableName']
  },
  {
    value: '0x09',
    text: '09 - Se variável X == 1, então vai para a tela Y',
    paramTypes: ['variableName', 'screenIndex']
  },
  {
    value: '0x0a',
    text: '0a - Se checklist NOK, envia e vai pra tela X, senão vai pra tela Y',
    paramTypes: ['screenIndex', 'screenIndex']
  }
]

export function translateBacklight(x) {
  let item = backlightOpts.find(y => y.value == x)
  return item ? item.text.substring(5) : `?? ${x} ??`
}

export function translateFunc(x) {
  let item = funcOpts.find(y => y.value == x)
  return item ? 'Função ' + item.text.slice(5) : `?? ${x} ??`
}

export function translateVar(hexCode) {
  let variable = varsWithHex.find(x => x.hexCode == hexCode)
  return variable ? variable.code : `?? ${hexCode} ??`
}
